import { render } from "./AdminNotificationEdit.vue?vue&type=template&id=40de8f4d&scoped=true&ts=true&lang=true"
import script from "./AdminNotificationEdit.vue?vue&type=script&lang=ts"
export * from "./AdminNotificationEdit.vue?vue&type=script&lang=ts"

import "./AdminNotificationEdit.vue?vue&type=style&index=0&id=40de8f4d&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40de8f4d"]])

export default __exports__